












































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import PDFViewer from "@/components/PDFViewer.vue";

@Component({
  components: {
    PDFViewer
  }
})
export default class PreviewPDFModal extends Vue {
  @Prop() value: boolean;
  @Prop() pdfUrl: string;
  @Prop({ default: "100%" }) viewerWidth: string;
  @Prop({ default: "1000px" }) modalWidth: string;
  @Prop({ default: "Pratinjau Form" }) modalTitle: string;
  @Prop({ type: Boolean, default: false }) readonly hidePrint!: boolean;
  @Ref() pdfEl: any;

  print() {
    this.pdfEl.print();
  }

  close() {
    this.$emit("input", false);
  }
}
